<script lang="ts">
import { defineComponent } from 'vue';
import Pagination from '@/components/pagination.vue';
import Types from '@/components/pools/pool-types/types.vue';
import Categories from '@/components/pools/pool-types/categories.vue';

export default defineComponent({
  name: 'pool-types',
  components: { Pagination, Types, Categories },
});
</script>

<template>
  <types />
  <categories />
</template>

<style scoped lang="scss"></style>
